<script setup>
import { Loader } from "@googlemaps/js-api-loader"
const { locationsByState, getLocationsByDivision } = useLocationData();

const props = defineProps({
  data: Object
})

const division = props.data.map.divisions.includes('all') || props.data.map.divisions.length == 2  ? 'all' : props.data.map.divisions[0];
const locationId = props.data.map.locationId !== null ? props.data.map.locationId : 0

const request = {
  "division": division,
  "locationId": locationId
}

const {data: locations} = await getLocationsByDivision(JSON.stringify(request));

const locationData = {
  current: locationId,
  locations: locations.value
}

onMounted( async () => {
  const { key } = await $fetch('/api/maps-key');

  const loader = new Loader({
    apiKey: key,
    version: "weekly",
    libraries: ["marker"]
  });

  const map = {
    data: locationData,
    wrap: document.getElementById('nearby-locations-wrap'),
    el: document.getElementById('nearby-locations-map'),
    gm: null, // the google map instance ( google.maps.Map class )
    init() {
      map.gm = new google.maps.Map(map.el, map.options());
      // initialize dependencies
      [data, markers, infoWindow, nearby, events].forEach(dep => dep.init());
    },
    reset: false,
    loaded() {
      return Boolean(document.getElementById('nlm-gm-js-api'));
    },
    options() {      
      return {
        center: idToLatLng(map.data.current),
        zoom: locationData.current > 0 ? 15 : (window.innerWidth <= 768 ? 3 : ((window.innerWidth > 768 && window.innerWidth < 1200) ? 4 : 5)),
        disableDefaultUI: true,
        zoomControl: true,
        mapId: 'location-map',
        zoomControlOptions: {
          position: google.maps.ControlPosition.TOP_RIGHT
        },
        // styles: [
          
        //   {
        //     featureType: "road.highway",
        //     elementType: "geometry",
        //     stylers: [{ color: "#8EA7C3" }],
        //   },
        //   {
        //     featureType: "road.highway",
        //     elementType: "geometry.stroke",
        //     stylers: [{ visibility: "off" }],
        //   },
        //   {
        //     featureType: "water",
        //     elementType: "geometry",
        //     stylers: [{ color: "#70D3E7" }],            
        //   },
        //   {
        //     featureType: "water",
        //     elementType: "labels.text.fill",
        //     stylers: [{ color: "#185abc" }],
        //   }
          
        // ]
      }
    }
  };

  loader.importLibrary('maps').then(async () => {
    map.init()
  })

  const data = (() => {
    const closest = [];

    function setLatLng(location) {
      if (location) {
        location.LatLng = new google.maps.LatLng(location.latitude, location.longitude);
      }
      // location.LatLng = new google.maps.LatLng(location.latitude, location.longitude);
    }

    function setDistance(location) {
      // location.gmDistance = google.maps.geometry.spherical.computeDistanceBetween(currentLocation().LatLng, location.LatLng) / 1609.34;
      location.gmDistance = location.distance;
    }

    function updateClosest() {
      closest.sort((a,b) => locationById(a).gmDistance - locationById(b).gmDistance);
      if (closest.length > 3) closest.pop();
    }
    

    return {
      init() {
        setLatLng(currentLocation());        
        Object.keys(map.data.locations).forEach(id => {
          if (isCurrent(id)) return;
          let location = map.data.locations[id];
          setLatLng(location);          
          setDistance(location)

          if (locationData.current > 0) {
            closest.push(id);
            updateClosest();
          }          
        });
        map.data.nearby = closest.map(id => parseInt(id, 10));
        
      }
    }
  })();

  function isCurrent(id) {
    return map.data.current == id;
  }

  function locationById(id) {
    return map.data.locations[id];
  }

  function locationType(id) {
    return isCurrent(id)
      ? 'current'
      : isNearby(id)
      ? 'nearby'
      : 'default';
  }

  function currentLocation() {
    return map.data.locations[map.data.current];
  }

  function existsCurrentLocation() {
    return map.data.locations[map.data.current];
  }

  function idToLatLng(id) {
    let location = locationById(id);
    const center = { latitude: 32.0902, longitude: -95.7129 };

    if (window.innerWidth > 576 && window.innerWidth < 992) {
      center.latitude = 27.0902;
    }
    else if (window.innerWidth >= 1200 && window.innerWidth < 1600) {
      center.latitude = 35.0902;
    }
    else if (window.innerWidth >= 1600) {
      center.latitude = 36.0902;
    }

    return new google.maps.LatLng(location ? location.latitude : center.latitude, location ? location.longitude : center.longitude);
  }

  function isNearby(id) {
    return map.data.nearby.indexOf(parseInt(id, 10)) > -1;
  }

  function resetMapCenter() {
    map.gm.panTo(locationById(map.data.current).LatLng);
  }

  function setZoom(zoom) {
    map.gm.setZoom(zoom)
  }

  function scrollTop() {
    return window.pageYOffset || document.documentElement.scrollTop;
  }


  const markers = (() => {
    const _refs = {};
    const iconPath = 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z';
    const icons = {
      current: {
        anchor: { x: 12, y: 16 },
        color: '#07937b',
        scale: 2.5,
        zIndex: 100,
      },
      default: {
        anchor: { x: 12.5, y: 24 },
        color: "#9ac92f",
        scale: 2,
        zIndex: 1,
      },
      nearby: {
        anchor: { x: 12, y: 16 },
        color: ['#12b0ea', '#b812ea', '#ea7612' ],
        scale: 2.5,
        zIndex: 99,
      }
    };

    let nearbyIndex = 0;

    function create(id) {
      const type = locationType(id);      
      let icon = icons[type];
      google.maps.importLibrary("marker").then((marker) => {

        let color = icon.color;
        if (type === 'nearby') {
          color = icon.color[nearbyIndex];          
        }

        

        _refs[id] = new marker.AdvancedMarkerElement({
          // animation: google.maps.Animation.DROP,            
          map: map.gm,
          content: buildContent(color),
          position: idToLatLng(id),
          title: locationById(id).pulseName,            
          zIndex: icon.zIndex
        });          
        _refs[id].addListener('click', clicked(id));        
        
        if (isNearby(id)) {
          nearbyIndex++;
        }

        if (!isCurrent(id)) {
          const content = _refs[id].content;

          content.style.opacity = "0";
          content.addEventListener("animationend", (event) => {
            content.classList.remove("drop");
            content.style.opacity = "1";
          });

          const time = 1 + Math.random(); // 2s delay for easy to see the animation

          content.style.setProperty("--delay-time", time + "s");
        
          intersectionObserver.observe(content);
        }

      });
    }

    const intersectionObserver = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add("drop");
          intersectionObserver.unobserve(entry.target);
        }
      }
    });

    function buildContent(color) {
      const content = document.createElement("div");

      content.classList.add("location-marker");
      content.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="56" height="64" fill="${color}" stroke="#ffffff" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>`;
      return content;
    }

    function exists(id) {
      return _refs.hasOwnProperty(id);
    }

    function setVisibility(id, visible) {
      if (_refs[id]) {
        _refs[id].visibility = visible;
      }
      
    }

    function setZIndex(id, zIndex) {
      if (_refs[id]) {
        _refs[id].zIndex = zIndex;
      }      
    }

    function clicked(id) {
      return e => infoWindow.show({id});
    }

    function update() {
      const gmLatLngBounds = map.gm.getBounds();
      Object.keys(_refs).forEach(id => {
        const gmLatLng = idToLatLng(id);
        const isWithinBounds = gmLatLngBounds.contains(gmLatLng);
        setVisibility(id, isWithinBounds);
      });
    }

    function updateNearbyMarkers(isNearbyActive) {
      let icon = isNearbyActive ? icons.nearby : icons.default;
      map.data.nearby.forEach((id, index) => {
        let map = _refs[id].map;
        _refs[id].setMap(null);
        _refs[id].icon.anchor = icon.anchor;
        _refs[id].icon.fillColor = isNearbyActive ? icons.nearby.color[index] : icon.color;
        _refs[id].icon.scale = icon.scale;
        _refs[id].icon.zIndex = icon.zIndex;
        _refs[id].setMap(map);
      });
    }

    return {
      init() {
        Object.keys(map.data.locations).forEach(id => create(id));
        [...map.data.nearby].reverse().forEach((id, index) => setZIndex(id, index + 2));
        setZIndex(map.data.current, 99);
        setVisibility(map.data.current, true);
        
      },
      show(ids = [], condition = null) {
        ids.forEach(id => {
          if (!condition || condition(id)) {
            if (!exists(id)) create(id);
            setVisibility(id, true);
          }
        })
      },
      hide(ids = []) {
        ids.forEach(id => setVisibility(id, false));
      },
      hideAll() {
        Object.keys(_refs).forEach(id => setVisibility(id, false));
      },
      update,
      updateNearbyMarkers
    }
  })();

  const infoWindow = (() => {
    let active = null;
    let pendingUpdate = 0;

    function content(id) {
      const location = locationById(id);
      const locType = locationType(id);
      let locationTitle = locationNameClass(id);
      if (locType === 'nearby') { locationTitle += nearby.isActive() ? "" : "--uniform"; }
      return `<div class="map-info-window ${locType}">
        <address>
          <a class="${locationTitle}" href="${location.link}">${location.pulseName}</a>
          <br>
          ${location.addressArea} ${location.postalCode}
        </address>
      </div>`;
    }

    function locationNameClass(id) {
      const type = locationType(id);
      return type == 'nearby' ? type + '-' + (map.data.nearby.indexOf(parseInt(id, 10)) + 1) : type;
    }

    function create(id) {
      return new google.maps.InfoWindow({
        content: content(id),
        position: idToLatLng(id),
        pixelOffset: new google.maps.Size(0, -48),
        id: id
      });
    }

    function setActive(id = 0) {
      active = id ? create(id) : null;
    }

    function showActive() {
      if (active) active.open({ map: map.gm, shouldFocus: false });
    }

    function hideActive() {
      if (active) active.close();
    }

    function recreateActive() {
      if (active) {
        hideActive();
        setActive(active.id);
        showActive();
      }
    }

    function open(id) {
      hideActive();
      setActive(id);
      showActive();
      map.gm.panTo(idToLatLng(id));
      map.gm.panBy(0, -100);
    }

    function reset() {
      const id = map.data.current;
      open(id);
    }

    return {
      init() {
        setTimeout(reset, 1000);
      },
      reset() {
        const id = map.data.current;
        pendingUpdate = id;
        setTimeout(() => {
          if (pendingUpdate == id) open(id);
        }, 100);
      },
      show({ id = 0 }) {
        if (id) {
          pendingUpdate = id;
          setTimeout(() => {
            if (pendingUpdate == id) open(id);
          }, 100);
        }
      },
      recreateActive
    }
  })();

  const nearby = (() => {
    const wrap = document.querySelector('.nearest-locations');
    const toggle = document.getElementById('toggle-nl');
    const card = {
      touched: false,
      els: [],
      selector: '.nl-cards>.nl-card',
      listeners: {
        mouseenter({ target: cardEl }) {
          activate(cardEl);
        },
        mouseleave({ target: cardEl }) {
          if (!card.touched) deactivate(cardEl, true);
        },
        touchstart({ target: touchEl }) {
          const cardEl = cardElFromTouch(touchEl);
          card.touched = true;
          deactivate(activeCard());
          activate(cardEl);
        }
      }
    };

    function isActive() {
      if (!wrap) return false;
      return wrap.classList.contains('open');
    }

    function toggleNearby() {
      isActive() ? close() : open();
      markers.updateNearbyMarkers(isActive());
    }

    function open() {
      const gmLatLngBounds = new google.maps.LatLngBounds();
      normalizeScroll();
      setCardEls();
      createCardContent();
      wrap.classList.add('open');
      resetMapCenter();
      [map.data.current, ...map.data.nearby].forEach(id => {
        const gmLatLng = idToLatLng(id);
        gmLatLngBounds.extend(gmLatLng);
      });
      map.gm.fitBounds(gmLatLngBounds, mapPadding());
      map.gm.panToBounds(gmLatLngBounds);
      cardEventListeners('add');
      //infoWindow.recreateActive();
      infoWindow.reset();
    }

    function close() {
      cardEventListeners('remove');
      wrap.classList.remove('open');
      resetMapCenter();
      map.gm.setZoom(map.options().zoom);
      deactivate(activeCard(), true);
    }

    function setCardEls() {
      if (!card.els.length) card.els = wrap.querySelectorAll(card.selector);
    }

    function createCardContent() {
      map.data.nearby.forEach((id, index) => {
        let location = locationById(id);        
        let el = card.els.item(index);
        el.setAttribute('data-location-id', id);
        el.innerHTML = cardInnerHtml(location)
      })
    }

    function cardInnerHtml(location) { 
      const statusVariant = location.statusName.replace(/\s+/g, '-').toLowerCase();
      // Placeholder image added temporary
      const locationImage = location.listing_image_thumbnail ? location.listing_image_thumbnail.url : 'https://placehold.co/600x400';
      return ` 
        <div class="nl-area"> 
          <div class="nl-info-area"> 
            <div class="nl-image-area"> 
              <img class="nl-thumbnail mw-100 rounded-4" src="${locationImage}"/> 
            </div> 
            <div class="nl-detail"> 
              <h6 class="nl-name">${location.pulseName}</h6> 
              <div class="location-status location-status--${statusVariant} location-status--no-dot">${location.statusName}</div> 
              <small>${parseFloat(location.gmDistance).toFixed(2)} miles away</small> 
            </div> 
          </div> 
        </div> 
        <div class="nl-area nl-link-area"> 
          <a class="nl-link button btn btn-outline-secondary" href="${location.link}">Learn More</a> 
        </div>`; 
    } 

    function mapPadding() {
      return window.innerWidth < 987
      ? { top: 200, right: 50, bottom: 10, left: 50 }
      : { top: 300, right: 50, bottom: 50, left: 50 };
    }

    function supportsScrollTo() {
      return 'scrollBehavior' in document.documentElement.style;
    }

    const offset = () => {      
      if (window.innerWidth < 987) {
        return 400;
      }
      else if (window.innerWidth > 992 && window.innerWidth < 1200){
        return -200;
      }
      return -100;
    }

    function normalizeScroll() {
      if (!supportsScrollTo()) return;
      const { bottom } = map.wrap.getBoundingClientRect();
      
      const scrollTopTo = scrollTop() - (window.innerHeight - bottom) + offset() ;
      window.scrollTo({
        top: scrollTopTo,
        behavior: 'smooth',
      });
    }

    function cardEventListeners(addOrRemove) {
      card.els.forEach(cardEl => {
        Object.keys(card.listeners).forEach(eventName => {
          cardEl[`${addOrRemove}EventListener`](eventName, card.listeners[eventName], false);
        });
      });
    }

    function activeCard() {
      return wrap.querySelector('.nl-active');
    }

    function cardElFromTouch(touchEl) {
      let el = touchEl;
      while (el.parentElement && !el.getAttribute('data-location-id')) {
        el = el.parentElement;
      }
      return el.getAttribute('data-location-id') ? el : null;
    } 

    function activate(cardEl) {
      const id = cardEl.getAttribute('data-location-id');
      infoWindow.show({id});
      cardEl.classList.add('nl-active');
    }

    function deactivate(cardEl, reset = false) {
      if (cardEl) cardEl.classList.remove('nl-active');
      if (reset) infoWindow.reset();
    }

    return {
      init() {
        if (wrap && toggle) toggle.addEventListener('click', toggleNearby);
      },
      isActive,
    }
  })();

  const events = (() => {

    const listeners = {
      bounds_changed: {
        fn: markers.update,
        active: false
      },
      zoom_changed: {
        fn: markers.update,
        active: false
      }
    };

    function throttleHandler(eventName) {
      return () => {
        if (!listeners[eventName].active) {
          listeners[eventName].active = setTimeout(e => {
            listeners[eventName].fn(e);
            listeners[eventName].active = false;
          }, 200);
        }
      }
    }
    
    return {
      init() {
        Object.keys(listeners).forEach(eventName => {
          map.gm.addListener(eventName, throttleHandler(eventName));
        });
      }
    }
  })();

  
  window.addEventListener("resize", (event) => {
    const windowWidth = window.innerWidth
    if (locationData.current === 0) {
      if (windowWidth < 576) {
        setZoom(3)
      }
      else if (windowWidth > 576 && windowWidth < 992) {        
        setZoom(4)
      }
    }
   
  });
  
})
</script>

<template>
  <div >
    <div id="nearby-locations-wrap" class="block location-map" >
      <div class="text-center my-7">
        <h3>{{ sectionTitle }}</h3>
      </div>
      <div id="nearby-locations-map"></div>
      <div class="nearest-locations" v-if="locationData.current > 0 && data.map.findNearbyLocations">
        <button class="nl-button d-flex align-items-center justify-content-center py-2" id="toggle-nl">
            <span>Find nearby locations</span>
            <span class="icon-plus-circle1 ms-1 nl-button-icon"></span>
        </button>
        <div class="nl-cards">
          <div class="nl-card"></div>
          <div class="nl-card"></div>
          <div class="nl-card"></div>
        </div>
      </div>
    </div>
    
  </div>
  
</template>

<style lang="scss">
.location-marker {
  top: 10px;
  position: relative;
}

@keyframes drop {
  0% {
    transform: translateY(-200px) scaleY(0.9);
    opacity: 0;
  }
  5% {
    opacity: 0.7;
  }
  50% {
    transform: translateY(0px) scaleY(1);
    opacity: 1;
  }
  65% {
    transform: translateY(-17px) scaleY(0.9);
    opacity: 1;
  }
  75% {
    transform: translateY(-22px) scaleY(0.9);
    opacity: 1;
  }
  100% {
    transform: translateY(0px) scaleY(1);
    opacity: 1;
  }
}
.drop {
  animation: drop 0.3s linear forwards var(--delay-time);
}


#nearby-locations-wrap {
  position: relative;

  .current-location {

    .cl {
      &-address {
        padding-right: 4rem;

        h2 {
          font-size: 2rem;
          color: #07937b;
          line-height: 1.25;
        }

        h3 {
          font-size: 1.25rem;
          line-height: 1.25;
        }

        h4 {
          font-size: 1rem;
        }

        &::after {
          content: "";
          display: block;
          width: 2px;
          height: 100%;
          background: #ddd;
          position: absolute;
          top: 0;
          right: 2rem;
        }

        @include media-breakpoint-down(sm) {
          padding-right: 0;

          &::after {
            display: none;
          }
        }
      }
    }
  }

  #nearby-locations-map {
    height: 350px;
    transition: height 1s ease;
    background: #f7f7f7;

    @include media-breakpoint-up(md) {
      height: 800px;
    }
  }

  .map-info-window {
    font-family: Poppins, sans-serif;
    font-size: .9rem;

    a {
      color: #444;
      font-weight: bold;
      font-size: 1em;
      letter-spacing: normal;

      &.current {
        color: #07937b
      }

      &.nearby {

        &-1 {
          color: #b812ea;
        }

        &-2 {
          color: #ea7612;
        }

        &-3 {
          color: #12b0ea
        }
      }
    }

    &.default {
        font-size: .9rem
    }

    &.current a {
      color: #07937b
    }
  }

  .nearest-locations {
      position: absolute;
      bottom: 800px - calc(60px / 2);
      left: 5%;
      width: 250px;
      max-width: 1140px;
      margin: 0 auto;
      height: 60px;
      transition: all .3s ease;
      transition-property: height, bottom;

      &.open {
        height: 305px;
        border-radius: 27px;
        box-shadow: 0 7px 19px 0 rgba(0, 0, 0, 0.16);
        background: $color-secondary;

        .nl-button-icon {
          transform: rotate(45deg);
        }

        .nl-cards {
          display: flex;          
        }

        .nl-card {
          cursor: pointer;
          transform: translate3d(0, 0, 0);
          border-radius: 12px;
          border-top: 12px solid;
        }

        @include media-breakpoint-up(lg) {
          width: 90%;
          bottom: 800px - 305px + calc(80px / 2);

          .nl-button {            
            border: 0px;
            box-shadow: unset;
            max-width: 250px;            
          }
        }

        @include media-breakpoint-down(lg) {
          border-radius: unset;
        }
      }

      @include media-breakpoint-down(lg) {
        position: relative;
        width: 100%;
        bottom: 0;
        left: 0;
      }

      @media (min-width: 1140px) {
        left: calc((100% - 1140px) / 2);
      }

      .nl {
        &-button {
          width: 100%;
          text-align: left;
          line-height: 2.5rem;
          background: none;
          border: none;
          font-weight: bold;
          letter-spacing: normal;
          outline: none;
          border: solid 1px #d9d9d9;
          background: #fff;
          border-radius: 27px;
          box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.16);

          span {
            font-weight: 600;            
          }

          @include media-breakpoint-down(lg) {
            width: 100%;
            bottom: 0;
            border-radius: unset;
          }
          
        }

        &-button-icon {
          height: 16px;
          width: 16px;
          border: 2px solid #333;
          display: inline-block;
          position: relative;
          vertical-align: middle;
          margin: -0.2rem 0 0 1rem;
          border-radius: 50%;
          transition: transform .4s ease;
          transform-origin: center;
          margin-top: 1px;
          @include media-breakpoint-down(md) {
            float: right;
          }

          &%button-icon-psuedo {
            content: "";
            display: block;
            height: 8px;
            width: 0.15rem;
            background: #333;
            position: absolute;
            right: 0;
            left: 0;
            margin: 0 auto;
            top: 50%;
          }

          &::before {
            @extend %button-icon-psuedo;
            transform: translateY(-50%);
          }

          &::after {
            @extend %button-icon-psuedo;
            transform: translateY(-50%) rotate(90deg);
          }
        }

        &-cards {
          display: none;
          flex-flow: row nowrap;
          height: 14rem;
          padding-top: 1rem;
          overflow-x: auto;
          overflow-y: hidden;
          
          &::-webkit-scrollbar {
            display: none;
          }
        }

        &-card {
          display: flex;
          flex-flow: column nowrap;
          flex-grow: 1;
          flex-basis: 300px;
          justify-content: space-between;
          position: relative;          
          min-width: 300px;
          height: 100%;
          margin: -.8rem .8rem .8rem;
          padding: .8rem;
          border-radius: 4px;
          box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.16);          
          color: #333;
          transition: all ease-in-out .4s;
          animation: fadeInUp .3s cubic-bezier(.4,0,0,1) .4s forwards;
          transform: translate3d(0, 50%, 0);

          &:nth-child(1) {
            border-color: #b812ea;
          }
          
          &:nth-child(2) {
            border-color: #ea7612;
          }
      
          &:nth-child(3) {
            border-color: #12b0ea;
          }
      
          &.nl-active {
            margin-top: -1rem;
          }

          
          @include media-breakpoint-down(sm) {
            flex-basis: 250px;
            min-width: 250px;
          }
        }
        
        &-image-area {
          width: 50%;
          min-width: 50%;
          margin-right: .8rem;
        }
        &-info-area {
          display: flex;
          flex-flow: row nowrap;
        }
        &-link-area {
          align-self: flex-end;
        }

        &-thumbnail {
          width: 100%;
          border-radius: .25rem;
          margin-right: .8rem;
        }
        &-detail {
          display: flex;
          flex-flow: column nowrap;
          //flex-grow: 1;
          justify-content: center;
          flex: 1 1 50%;
        }
        &-name {
          margin: 0;
          color: #333;

          @include media-breakpoint-down(sm) {
            font-size: 14px;
          }
        }
        &-link {
          border-width: 1px;
          text-align: center;
          width: auto;
          padding: .33rem 1rem;
          height: auto;
          line-height: 1.4;
          font-size: .75rem;
          font-weight: bold;
        }
      }
    }
}


</style>